import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { FlashMessage } from '../aura';
import { BusinessSegment } from './input';
import { Form, Prompt, Title } from './templates';

export function StepTwoForm() {
  const { t } = useTranslation('stepTwoForm');
  const [error, setError] = useState<string | null>(null);

  return (
    <Form>
      {error && (
        <FlashMessage
          message={error}
          flavor="error"
          onDismiss={() => setError(null)}
        />
      )}
      <Title text={t('title')} showStepCounter />
      <Prompt text={t('prompt1')} />
      <BusinessSegment onError={setError} />
    </Form>
  );
}
